import { TableCell, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

const WorkHistoryTableHeaders = () => {
  const { t } = useTranslation("workHistory");
  return (
    <TableHead>
      <TableRow>
        <TableCell width="16px" />
        <TableCell
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            padding: "0.5rem 0.5rem 0.5rem 0",
          }}
        >
          {t("workTitle")}
        </TableCell>
        <TableCell
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            padding: "0.5rem",
            textAlign: "center",
          }}
        >
          {t("date")}
        </TableCell>
        <TableCell width="25%" />
      </TableRow>
    </TableHead>
  );
};

export default WorkHistoryTableHeaders;
